import { createCachedSelector, path, defaultKeySelector } from '@cbridge-utils/redux';
import { notificationStoreSelector } from '@cbridge-packages/notification';

export const notificationsPropsSelector = createCachedSelector(
  [
    path(notificationStoreSelector).queue(),
  ],
  (queue) => {
    return {
      notifications: queue ?? [],
    };
  },
)({
  keySelector: defaultKeySelector,
});
